var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRobotTalk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Asset 7 1"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_61_1454)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M44.0692 34.8815C45.9384 31.5103 47.0056 27.6308 47.0056 23.5028C47 10.5204 36.4796 0 23.5028 0C10.5317 0 0 10.5317 0 23.5028C0 36.4796 10.5204 47.0056 23.5028 47.0056C27.8058 47.0056 31.8378 45.848 35.3051 43.832L43.7869 46.4353C45.5826 46.9887 47.2711 45.3059 46.7177 43.5045L44.0692 34.8815Z",
    fill: "url(#paint0_linear_61_1454)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25.2704 15.0663C25.2704 14.0902 24.479 13.2988 23.5029 13.2988C22.5267 13.2988 21.7354 14.0902 21.7354 15.0663V31.9396C21.7354 32.9158 22.5267 33.7071 23.5029 33.7071C24.479 33.7071 25.2704 32.9158 25.2704 31.9396V15.0663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.6976 18.3925C17.6976 17.4163 16.9063 16.625 15.9301 16.625C14.9539 16.625 14.1626 17.4163 14.1626 18.3925V27.8117C14.1626 28.7879 14.9539 29.5792 15.9301 29.5792C16.9063 29.5792 17.6976 28.7879 17.6976 27.8117V18.3925Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.1251 21.2553C10.1251 20.2791 9.33377 19.4878 8.3576 19.4878C7.38143 19.4878 6.59009 20.2791 6.59009 21.2553V25.0275C6.59009 26.0037 7.38143 26.795 8.3576 26.795C9.33377 26.795 10.1251 26.0037 10.1251 25.0275V21.2553Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M29.308 27.7667C29.308 28.7428 30.0993 29.5342 31.0755 29.5342C32.0517 29.5342 32.843 28.7428 32.843 27.7667V18.3475C32.843 17.3713 32.0517 16.58 31.0755 16.58C30.0993 16.58 29.308 17.3713 29.308 18.3475V27.7667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M36.8749 24.9092C36.8749 25.8854 37.6662 26.6768 38.6424 26.6768C39.6186 26.6768 40.4099 25.8854 40.4099 24.9092V21.1371C40.4099 20.1609 39.6186 19.3695 38.6424 19.3695C37.6662 19.3695 36.8749 20.1609 36.8749 21.1371V24.9092Z",
    fill: "white"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_61_1454",
    x1: 0,
    y1: 23.5028,
    x2: 47,
    y2: 23.5028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B200F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4219A0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_61_1454"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobotTalk);
export default __webpack_public_path__ + "static/media/robot-talk.8bd69fbbdda1f9a7693eb2e7973894fa.svg";
export { ForwardRef as ReactComponent };